module.exports = __webpack_public_path__ + "img/yl3033.b69b7002.png";